import { FC, useEffect, useState } from 'react';
import ContentRenderer from '../Content/ContentRenderer';
import './ScssRenderer.scss';

type ScssRendererProps = {
	fieldName: string;
	scssText: string;
};

enum CssTab {
	CSS = 'css',
	SCSS = 'scss',
}

const ScssRenderer: FC<ScssRendererProps> = ({ fieldName, scssText }) => {
	const [compiledCss, setCompiledCss] = useState('');
	const [showCurrentTab, setShowCurrentTab] = useState<CssTab>(CssTab.SCSS);
	// TODO: fix custom event type
	const eventName: string = `compiledScss_${fieldName}`;
	const eventCallback = (data: any) => {
		const compiled = data?.detail?.compiledScss;
		const cssString = compiled
			? `<pre><code class="language-css">${compiled}</code></pre>`
			: '';
		setCompiledCss(cssString);
	};

	useEffect(() => {
		window.document.addEventListener(eventName, eventCallback);
		return () => {
			window.document.removeEventListener(eventName, eventCallback);
		};
	}, [eventName]);

	return (
		<div className="ScssRendererProps">
			{scssText && showCurrentTab === CssTab.SCSS ? (
				<div className="ScssRendererProps__tab-wrapper">
					{compiledCss && (
						<div
							className="ScssRendererProps__show-complied scss"
							onClick={() => setShowCurrentTab(CssTab.CSS)}
						>
							Show compiled CSS
						</div>
					)}
					<ContentRenderer html={scssText} />
				</div>
			) : null}
			{compiledCss && showCurrentTab === CssTab.CSS ? (
				<div className="ScssRendererProps__tab-wrapper">
					<div
						className="ScssRendererProps__show-complied css"
						onClick={() => setShowCurrentTab(CssTab.SCSS)}
					>
						Show original SCSS
					</div>
					<ContentRenderer html={compiledCss} />
				</div>
			) : null}
		</div>
	);
};

export default ScssRenderer;
